import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { Store } from '@sama/app-state';
import { DirectiveSuperclass } from '@sama/ng-core';
import { Point3D } from '../../../team-apis/otterdam/answers/shape-typings';

@Component({
  selector: 'h3-coordinates-control',
  templateUrl: './coordinates-control.component.html',
  styleUrls: ['./coordinates-control.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CoordinatesControlComponent
  extends DirectiveSuperclass
  implements OnInit
{
  @Input({ required: true }) coordinateStore!: Store<Point3D>;

  x = 0;
  y = 0;
  z = 0;

  ngOnInit() {
    const point = this.coordinateStore.state();
    const roundedCoordinates = this.toRoundedPoint3D(point);
    this.x = roundedCoordinates[0];
    this.y = roundedCoordinates[1];
    this.z = roundedCoordinates[2];
  }

  protected updateStore(value: number, coordinateIndex: number) {
    this.coordinateStore.setUsing((state) => {
      const newState = [...state];
      newState[coordinateIndex] = value;
      return newState as Point3D;
    });
  }

  private toRoundedPoint3D(point: number[]) {
    return point.map(
      (coord) => Math.round((coord + Number.EPSILON) * 100) / 100,
    ) as Point3D;
  }
}
